import { useEffect, useState } from "react";

// Registrazione service worker (app installabile) e cattura del prompt di installazione Android
let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== "undefined") {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    });
  }
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((l) => l());
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    listeners.forEach((l) => l());
  });
}

export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const isIOSDevice = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const INSTALL_HELP = {
  android: "Apri il sito con Chrome sul telefono, poi menu \u22ee \u2192 \"Installa app\".",
  ios: "Apri il sito con Safari su iPhone/iPad, poi Condividi \u2192 \"Aggiungi alla schermata Home\".",
};

export function useInstallPrompt() {
  const [, force] = useState(0);
  useEffect(() => {
    const l = () => force((n) => n + 1);
    listeners.add(l);
    return () => listeners.delete(l);
  }, []);
  const install = async () => {
    if (!deferredPrompt) return false;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    deferredPrompt = null;
    listeners.forEach((l) => l());
    return true;
  };
  return { canInstall: !!deferredPrompt, install, installed: isStandalone() };
}
